import React, {useEffect} from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom'
import store from './store';
import Layouts from './layouts'

import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";

import './lang'
import SheetProvider from "./mobile/providers/SheetProvider";
import ActionSheetProvider from "./mobile/providers/ActionSheetProvider";

import { loadI18n} from './locales/index';
loadI18n()

function App() {

    return (
        <div className="App">
            <I18nProvider i18n={i18n}>
                <Provider store={store}>
                    <BrowserRouter>
                        <ActionSheetProvider>
                            <SheetProvider>
                                <Layouts/>
                            </SheetProvider>
                        </ActionSheetProvider>
                    </BrowserRouter>
                </Provider>
            </I18nProvider>
        </div>
    );
}

export default App;
